import React from 'react'
import {ActiveCampaignTag, useTestTag} from 'Event/activeCampaign'
import {ACTIVE_CAMPAIGN} from 'organization/Event/Services/ServicesProvider'
import TestTagButton from 'organization/Event/Form/TestTagButton'

export default function TestActiveCampaignTagButton(props: {
  tag: ActiveCampaignTag | null
}) {
  const addTag = useTestTag()

  return (
    <TestTagButton
      tag={props.tag}
      integration={ACTIVE_CAMPAIGN}
      addTag={addTag}
    />
  )
}
